import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { CrudStatusType } from 'src/app/enum/crud-status-type';
import { RoleType } from 'src/app/enum/role-type';
import { ExcelService } from 'src/app/services/excel.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { RoleService } from 'src/app/services/role.service';
import { ServiceProviderService } from 'src/app/services/service-provider.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import swal from 'sweetalert2';
import * as _ from "lodash";
@Component({
  selector: 'app-manage-service-provider',
  templateUrl: './manage-service-provider.component.html',
  styleUrls: ['./manage-service-provider.component.scss']
})
export class ManageServiceProviderComponent implements OnInit {
  data = [];
  dataSource = new MatTableDataSource(this.data);
  displayedColumns: string[] = [
    "providerName",
    "referenceName",
    "action"
  ];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
  dataExcel: any = [];
  excelColumns: string[];
  filterValue: string = "";
  roleTypeEnum = RoleType;
  sessionDataString: any;

  constructor(
    private ServiceProviderService: ServiceProviderService,
    private navigationService: NavigationService,
    private excelService: ExcelService,
    private loaderService: LoaderService,
    private toastr: NotificationService,
    private sessionService: UserSessionService,
  ) {

  }

  ngOnInit() {
    this.getTableData('');
    this.sessionDataString = JSON.parse(
      localStorage.getItem(this.sessionService.localStorageSessionKey)
    );
  }

  getTableData(data) {
    if (data) {
      data = { searchQuery: data }
    }
    this.ServiceProviderService.getManageServiceProviderList(data).subscribe((result) => {
      this.data = [];
      this.dataExcel = [];
      this.data = result;
      this.dataExcel = result;
      this.data = _.orderBy(this.data, ["priority"]);
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterValue = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  clearFilter() {
    const inputElement = document.getElementById('filter-input') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    this.dataSource.filter = '';
    this.searchInput.nativeElement.value = "";
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.dataSource.sort.active = '';
    this.dataSource.sort.direction = '';
    this.dataSource.sort.sortChange.emit({ active: '', direction: '' });
    this.getTableData('');
  }

  goToManageServiceForm(id,type) {
    this.navigationService.goToManageServiceForm(id,type);
  }

  deleteUser(user) {
    const txt = 'Are you sure want to delete ' + user.providerName + ' ?';
    const Yes = 'Yes';
    const No = 'No';
    swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.ServiceProviderService.deleteserviceProvider(user.id).subscribe((result: any) => {
          if (result && result.crudStatus == CrudStatusType.DataUpdatedSuccessfully) {
            this.toastr.showSuccess("Deleted Successfully");
            this.getTableData('');
          }
        });
      }
    });
  }

  exportAsXLSX(): void {
    this.loaderService.start();
    setTimeout(() => {
      var exportData = this.dataExcel;
      if (!exportData || exportData.length === 0) {
        this.toastr.showInfo("No data available to export");
        this.loaderService.hide();
        return;
      }
      const excelList = [];
      this.excelColumns = [
        "S.No",
        'Service Provider',
        'Referenace Name',
      ];
      exportData.forEach((a, index) => {
        excelList.push({
          sno: ++index,
          "providerName": a.providerName,
          "referenceName": a.referenceName
        });
      });
      this.excelService.exportAsExcelFile(excelList, "ServiceProvider_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
      this.loaderService.stop();
    }, 500);
  }

}
